import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';

import { NotFoundStatusCode } from 'utils/constants';

import CONTENTS_QUERY from 'graphql/content/queries/contents.graphql';

import type {
  GetContentsQuery,
  GetContentsQueryVariables,
} from 'graphql/types';
import { GetServerSidePropsContext } from 'next';

export const useContents = (variables?: GetContentsQueryVariables) =>
  useQuery<GetContentsQuery>(CONTENTS_QUERY, { variables });

export const getContentsSsr = async (
  ctx: GetServerSidePropsContext,
  client: ApolloClient<NormalizedCacheObject>,
  variables?: GetContentsQueryVariables
) => {
  try {
    const {
      data: { contents },
    } = await client.query<GetContentsQuery>({
      query: CONTENTS_QUERY,
      variables,
    });

    // проверка на урл нужна для того, чтобы страница /events/[slug] не возвращала 404,
    // если материалов у мероприятия нет
    if (!contents?.length && ctx.resolvedUrl.includes('materials')) {
      ctx.res.statusCode = NotFoundStatusCode;
    }
  } catch (err) {
    console.log(err);
  }
};
